// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"ce1907c8","456":"202c4294","669":"b459d837"}[chunkId] + ".css";
};